import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useOrganization } from '../../context/OrgContext';
import {
  LuArrowLeft, LuBuilding, LuBuilding2, LuCreditCard, LuSettings, LuUser, LuUsers,
} from "react-icons/lu";
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig'; // Adjust the import path to your Firebase config

const AdminSettings = () => {
  const { institution } = useOrganization();
  const navigate = useNavigate();
  const location = useLocation();

  // Handle settings navigation
  const handleBackClick = () => {
    navigate('/');
  };

  // Navigation items for the sidebar
  const institutionSettings = [
    { path: '/settings', label: 'General', icon: LuSettings()},
    { path: '/settings/users', label: 'Users', icon: LuUsers() },
    { path: '/settings/billing', label: 'Billing', icon: LuCreditCard() },
  ];

  const accountSettings = [
    { path: '/settings/profile', label: 'Profile', icon: LuUser() },
  ];

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="h-full relative w-full text-white px-8 pt-12 flex overflow-x-clip overflow-y-auto gap-8">
      <div className={"w-56 pt-2 pb-4 h-fit sticky -top-12 max-h-full overflow-clip flex flex-col space-y-3"}>
        <div className={"hover:bg-[#ffffff05] border border-[#ffffff10] flex-shrink-0 rounded-xl w-full h-16 p-2.5 cursor-pointer flex space-x-2"}>
          <div className={"h-full aspect-square bg-[#ffffff10] rounded-lg items-center justify-center flex"}>
            <LuBuilding2 className={"scale-110"}/>
          </div>
          <div className={"flex flex-col flex-1 h-full justify-center -space-y-0.5"}>
              <div className={"text-sm font-medium"}>{institution?.fullName}</div>
              <div className={"text-sm opacity-50"}>{institution?.domain}</div>
          </div>
        </div>

        {/* Institution Settings */}
        <div className={"h-fit w-full"}>
          <div className={"text-sm uppercase opacity-40 font-semibold mb-2"}>Institution</div>
          <div className="space-y-1">
            {institutionSettings.map((item) => (
              <div
                key={item.path}
                className={`text-sm group px-3 py-2 rounded-lg cursor-pointer transition-colors space-x-2 flex items-center ${
                  isActiveRoute(item.path)
                    ? 'bg-[#ffffff15] text-white'
                    : 'hover:bg-[#ffffff08] opacity-70 hover:opacity-100'
                }`}
                onClick={() => navigate(item.path)}
              >
                <div className={"group-hover:animate-wobble transition"}>{item.icon}</div>
                <div>{item.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Account Settings */}
        <div className={"h-fit w-full"}>
          <div className={"text-sm uppercase opacity-40 font-semibold mb-2"}>Account</div>
          <div className="space-y-1">
            {accountSettings.map((item) => (
                <div
                    key={item.path}
                    className={`text-sm group px-3 py-2 rounded-lg cursor-pointer transition-colors space-x-2 flex items-center ${
                        isActiveRoute(item.path)
                            ? 'bg-[#ffffff15] text-white'
                            : 'hover:bg-[#ffffff08] opacity-70 hover:opacity-100'
                    }`}
                    onClick={() => navigate(item.path)}
                >
                  <div className={"group-hover:animate-wobble transition"}>{item.icon}</div>
                  <div>{item.label}</div>
                </div>
            ))}
          </div>
        </div>
      </div>

      <div className={"flex-1 min-h-0 flex flex-col"}>
        <div className={"w-full h-fit border-b border-[#ffffff10] pb-4 flex justify-between"}>
          <div className={"text-3xl font-medium"}>General Settings</div>
          <div className={"flex space-x-3"}>
            <div
                className={"px-4 py-1.5 border border-[#ffffff10] space-x-2 rounded-lg flex items-center justify-center hover:bg-[#ffffff10] transition hover:border-[#ffffff15] cursor-pointer active:scale-95 transform duration-150 ease-out"}
                onClick={handleBackClick}
            >
              <LuArrowLeft/>
              <div>Back</div>
            </div>
          </div>
        </div>

        {/* Outlet for rendering subsections */}
        <div className={"w-full flex-1 pt-4 overflow-y-auto"}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;